import { motion } from "framer-motion";

const chapters = [
  {
    chapter: "01",
    title: "Why We Exist",
    heading: "No young person should spend their life stuck in a career they don't enjoy.",
    description: "We believe professional success is a natural byproduct of personal joy and alignment. When students choose from curiosity, fulfilment follows.",
  },
  {
    chapter: "02",
    title: "Where We Are Going",
    heading: "A generation that chooses careers out of genuine interest, not societal pressure.",
    description: "Our vision is an India where the younger generation explores first and decides with confidence — creating happier, more fulfilled professionals.",
  },
  {
    chapter: "03",
    title: "How We Get There",
    heading: "Actionable, engaging, scientifically backed career exploration.",
    description: "Certified psychometric instruments, 20+ years of people-development wisdom, and warm 1-to-1 mentorship that empowers students to decide boldly.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="py-20 sm:py-28" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-xs font-mono uppercase tracking-[0.25em] text-primary font-semibold mb-14"
        >
          Our Philosophy — The TheKhoj Manifesto
        </motion.p>

        <div className="space-y-0">
          {chapters.map((c, i) => (
            <motion.div
              key={c.chapter}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7 }}
              className={`grid grid-cols-1 lg:grid-cols-12 gap-6 py-10 ${i > 0 ? "border-t border-border" : ""}`}
              data-testid={`manifesto-chapter-${c.chapter}`}
            >
              <div className="lg:col-span-5">
                <p className="text-sm sm:text-base font-mono uppercase tracking-[0.2em] text-accent font-bold mb-2">{c.title}</p>
                <h3 className="font-display text-2xl sm:text-3xl font-bold tracking-tight leading-snug">{c.heading}</h3>
              </div>
              <div className="lg:col-span-7 flex items-end">
                <p className="text-muted-foreground text-base sm:text-lg leading-relaxed">{c.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
